import { Gallerie } from "@/src/data/types";
import { useEffect, useState } from "react";
import BreadCrumb from "../../../../../components/breadcrumb";
import Header from "../../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../../components/DashboardNavigation/sidebar";
import { StatutsData } from "../../../../../components/tables/statuts-tables/Statuts";
import { getAllStatuts } from "../../../../../API/Mediatheque/Statuts/statutsService";

const breadcrumbItems = [
  {
    title: "Statuts",
    link: "/admin-dashboard/mediatheque/statuts",
  },
];
export default function Statuts() {
  const [statuts, setStatuts] = useState<Gallerie[]>([]);
  const fetchData = async () => {
    const response = await getAllStatuts();
    setStatuts(response?.statuts);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <StatutsData data={statuts} />
        </div>
      </div>
    </>
  );
}
